import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const antIcon = <LoadingOutlined style={{ fontSize: 17 }} spin />;

const Spinner = (props) => <Spin {...props} style={{alignSelf:'center'}} indicator={antIcon} />;
export default Spinner;
